//IdentifyPopup.tsx =================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as ExpandOnPhone from "./ExpandOnPhone";
import * as GraLay from "../Util/GraLay";
import * as Identify from "./Identify";
import * as IdentifyPopup from "./IdentifyPopup";
import * as ResultsFS from "../Util/ResultsFS";
import * as Settings from "../Settings";
import * as Util from "../Util/Util";

import { CssBaseline, Icon, IconButton, Paper, Typography, Zoom } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";

import React from "react";
import ReactDOM from "react-dom/client";

const toolName: string = "Identify Results";
const toolWidget: string = "Identify_Widget";
const scrollDivID: string = toolName.replace(" ", "_") + "_Scroll";

export let toolVisible: boolean = false;
let results: ResultsFS.iResult[];
let widgetDiv: HTMLDivElement;

let top: number = 50;
let right: number = 3;
let left: number = null;

let mouseDown: boolean = false;
let begLeft: number;
let begTop: number;
let begX: number;
let begY: number;

let firstTime: boolean = true;
let root: ReactDOM.Root;

//Show the dialog.
export function show() {
   Util.logMsg("Showing Identify dialog");

   if (firstTime) {
      firstTime = false;
      document.body.addEventListener('mouseup', mouseUp, { capture: false, passive: true });
   }
   toolVisible = true;
   results = Identify.results_fs;

   if (!root) {
      root = ReactDOM.createRoot(document.getElementById("identify_div"));
   }
   root.render(<Render />);
}

//Dialog heading was dragged. if (event.nativeEvent.which === 1) {
function drag(mode: string, event: React.MouseEvent<HTMLDivElement>) {
   if (mode === "Down") {
      mouseDown = true;
      begLeft = widgetDiv.offsetLeft;
      begTop = widgetDiv.offsetTop;
      begX = event.clientX;
      begY = event.clientY;

   } else if (mode === "Move") {
      if (mouseDown) {
         left = begLeft + (event.clientX - begX);
         if (left < 1) {
            left = 1;
         }
         top = begTop + (event.clientY - begY);
         widgetDiv.style.left = left + "px";
         widgetDiv.style.top = top + "px";
      }
   }
}

//Disable drag mode.
function mouseUp() {
   mouseDown = false;
}

//Clear this tool.
export function clearTool() {
   GraLay.clearIdentifyHighlightGraphics();
   toolVisible = false;
}

//Process window resize event.
window.addEventListener('resize', function () {
   if (IdentifyPopup.toolVisible) {
      setPosition();
   }
}, { passive: true });

//Set widget screen positions.
export function setPosition(expand?: boolean, collapse?: boolean) {
   if (IdentifyPopup.toolVisible) {
      const height: number = Util.windowHeight();
      const width: number = Util.windowWidth();

      //Get widget and scroll div elements and height.
      const toolHeaderHeight: number = 84; //Includes drawer toolbar and active tool title panel.
      const scrollDiv: HTMLElement = document.getElementById(scrollDivID);

      //Position all components on desktop monitor.
      if (!collapse && (expand || (width > Settings.smallScreenWidth))) {

         if (expand) {
            widgetDiv.style.top = "37px";
            widgetDiv.style.maxHeight = (height + 1) + "px";
            const widgetBodyHeight: string = (height - toolHeaderHeight) + "px";
            scrollDiv.style.height = widgetBodyHeight;
            scrollDiv.style.maxHeight = null;

         } else {
            widgetDiv.style.top = top + "px";
            widgetDiv.style.maxHeight = null;
            scrollDiv.style.height = null;
         }

         if (left) {
            widgetDiv.style.left = left + "px";
            widgetDiv.style.right = null;
         } else {
            widgetDiv.style.left = null;
            widgetDiv.style.right = "3px";
         }

      } else { //Small screens.
         widgetDiv.style.top = (height / 2) + "px";
         widgetDiv.style.left = "1px";
         widgetDiv.style.right = null;
         widgetDiv.style.maxHeight = ((height / 2) + 30) + "px"; //Adjust as needed.

         if (scrollDiv) {
            const widgetBodyHeight: string = ((height / 2) - toolHeaderHeight + 30) + "px"; //Adjust as needed.
            scrollDiv.style.height = widgetBodyHeight;
         }
      }
   }
}

//Render function.
export function Render() {

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did update.
   React.useEffect(() => {
      widgetDiv = document.getElementById(toolWidget) as HTMLDivElement;
      setPosition();
   });

   //Close dialog.
   function handleClose() {
      clearTool();
      refresh();
   }

   let title: string = toolName;
   if (Identify.grandTotRec > 1) {
      title = "Identify (" + Identify.grandTotRec + " results)";
   }

   if (left) {
      right = null;
   }

   //css styles.
   const styles: Default.iStyles = {
      widgetDiv: { position: 'absolute', top: top, left: left, right: right, zIndex: 4, width: Settings.leftPanelWidth },
      heading: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: Settings.headingColor, borderTopLeftRadius: Settings.borderRadius, borderTopRightRadius: Settings.borderRadius, cursor: 'pointer' },
      toolDiv: { maxWidth: Settings.leftPanelWidth, padding: 7, maxHeight: 500, overflow: "auto" },
   };

   return (
      <ThemeProvider theme={Default.theme}>
         <CssBaseline />

         <Zoom in={IdentifyPopup.toolVisible} timeout={400} mountOnEnter unmountOnExit>
            <Paper id={toolWidget} style={styles.widgetDiv}>

               <div style={styles.heading} onMouseDown={(event) => drag("Down", event)} onMouseMove={(event) => drag("Move", event)}>
                  <Typography variant="body1" style={{ marginLeft: 12 }}>
                     {title}
                  </Typography>

                  <ExpandOnPhone.Render />

                  <IconButton size="medium" color="default" onClick={handleClose} title="Close" aria-label="Close">
                     <Icon color="action">close</Icon>
                  </IconButton>
               </div>

               <div id={scrollDivID} style={styles.toolDiv}>
                  <ResultsFS.Render results={results} />
               </div>

            </Paper>
         </Zoom>

      </ThemeProvider>
   ); //end return.

} //end function.
